import { format, parse, parseISO } from 'date-fns';
const formatAvailableDates = (dates) => Object.values(dates).map((date) => format(parse(date, 'yyyy-MM-dd', new Date()), 'yyyyMMdd'));
export const ISOFormatAvailableDates = (dates) => Object.values(dates).map((date) => format(parseISO(date), 'yyyyMMdd'));
export default formatAvailableDates;
